module.exports = __webpack_public_path__ + "static/flags/TC-787a8cf47c0b1a886c6d676ea554f773.gif";